export default {   
    profile: {
        name: "",
        registration_number: "",
        phone_number: "",
        height: "",
        weight: "",
        underlying_disease: ""
    },
    profile_specify: {
        name: '',
        registration_number: "",
    },
    agreements: {
        agreement_personal_info: false,
        agreement_location_service: false,
        agreement_marketing: false,
        agreement_terms_condition_description: false
    },
    card_info: {
        card_number: "",
        card_pw: "",
        card_ex_month: "",
        card_ex_year: "",
        card_nick_name: "",
        card_user_name: "",
        card_user_birth: ""
    }
}


// WEBPACK FOOTER //
// ./src/store/state.js